import { Button, FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';

export function Annotation({ test, changeFaceStatus, changeSpeechStatus, changeArmsStatus, changeNeurologicalExaminationStatus, changeReviewComplete }) {
  return (
    <>
      <Grid item xs={12}>
        <FormControl
          sx={{
            display: 'flex',
            width: '100%',
            margin: 'auto',
          }}
        >
          <InputLabel>Face Status</InputLabel>
          <Select value={test.faceStatus} size="small" onChange={(event) => changeFaceStatus(event.target.value)} input={<OutlinedInput label="Face Status" />}>
            <MenuItem value={'UNKNOWN'}>UNKNOWN</MenuItem>
            <MenuItem value={'VALID'}>VALID</MenuItem>
            <MenuItem value={'INVALID'}>INVALID</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl
          sx={{
            display: 'flex',
            width: '100%',
            margin: 'auto',
          }}
        >
          <InputLabel>Speech Status</InputLabel>
          <Select value={test.speechStatus} size="small" onChange={(event) => changeSpeechStatus(event.target.value)} input={<OutlinedInput label="Speech Status" />}>
            <MenuItem value={'UNKNOWN'}>UNKNOWN</MenuItem>
            <MenuItem value={'VALID'}>VALID</MenuItem>
            <MenuItem value={'INVALID'}>INVALID</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl
          sx={{
            display: 'flex',
            width: '100%',
            margin: 'auto',
          }}
        >
          <InputLabel>Arms Status</InputLabel>
          <Select value={test.armsStatus} size="small" onChange={(event) => changeArmsStatus(event.target.value)} input={<OutlinedInput label="Arms Status" />}>
            <MenuItem value={'UNKNOWN'}>UNKNOWN</MenuItem>
            <MenuItem value={'VALID'}>VALID</MenuItem>
            <MenuItem value={'INVALID'}>INVALID</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl
          sx={{
            display: 'flex',
            width: '100%',
            margin: 'auto',
          }}
        >
          <InputLabel>Neurological Examination Status</InputLabel>
          <Select value={test.neurologicalExaminationStatus} size="small" onChange={(event) => changeNeurologicalExaminationStatus(event.target.value)} input={<OutlinedInput label="Neurological Examination Status" />}>
            <MenuItem value={'UNKNOWN'}>UNKNOWN</MenuItem>
            <MenuItem value={'VALID'}>VALID</MenuItem>
            <MenuItem value={'INVALID'}>INVALID</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl
          sx={{
            display: 'flex',
            width: '100%',
            margin: 'auto',
          }}
        >
          <Button variant="contained" onClick={() => changeReviewComplete(true)}>
            Complete Review
          </Button>
        </FormControl>
      </Grid>
    </>
  );
}
